import { getData } from "./Http/api";

export const fetchSujetoIdentificacion = async () => {
  try {
    const response = await getData("/SujetoIdentificacionListar");
    return (response?.value || []).map((item) => ({
      idSujetoIdentificacion: item.idSujetoTipoIdentificacion,
      descripcion: item.tipoIdentificacion,
    }));
  } catch (ex) {
    console.error("Error cargando Tipos de Identificacion (helper):", ex);
    return [];
  }
};